import { Component, OnInit, Input } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { files } from './example-data';
import { MatDialog } from '@angular/material/dialog';
import { EditarMenuComponent } from '../editar-menu/editar-menu.component';
import { MenuService } from '../editar-menu/menu.service';
import { ModuloService } from '../modulo/modulo.service';
import { AplicacionesService } from '../aplicaciones/aplicaciones.service';
import { AccionesService } from '../acciones/acciones.service';

/** File node data with possible child nodes. */
export interface Menu {
  txt_ruta?: string;
  ind_estado : number;
  id_opcion_menu: number;
  txt_descripcion : string;
  fk_menu_padre? : number;
  child?: Menu[];                
}

/**
 * Flattened tree node that has been created from a FileNode through the flattener. Flattened
 * nodes include level index and whether they can be expanded or not.
 */
export interface FlatTreeNode {
  name: string;
  type: string;
  level: number;
  expandable: boolean;
}

@Component({
  selector: 'app-tree-accion-menu',
  templateUrl: './tree-accion-menu.component.html',
  styleUrls: ['./tree-accion-menu.component.scss']
})
export class TreeAccionMenuComponent implements OnInit {

  /** The TreeControl controls the expand/collapse state of tree nodes.  */
  treeControl: FlatTreeControl<FlatTreeNode>;

  /** The TreeFlattener is used to generate the flat list of items from hierarchical data. */
  treeFlattener: MatTreeFlattener<Menu, FlatTreeNode>;

  /** The MatTreeFlatDataSource connects the control and flattener to provide data. */
  dataSource: MatTreeFlatDataSource<Menu, FlatTreeNode>;
  @Input() datos : any;

  constructor(private dialog: MatDialog,
              private menu_serv : MenuService, 
              private mod_serv : ModuloService,
              private app_serv : AplicacionesService,
              private acc_serv : AccionesService) {
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren);

    this.treeControl = new FlatTreeControl(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  }
  ngOnInit(): void {
    this.dataSource.data = this.datos;
    this.acc_serv.tree_menu = this;
  }

  /** Transform the data to something the tree can read. */
  transformer(node: Menu, level: number) {

    let tipo = !node.txt_ruta? 'menu' : 'lens'
    return {
      name: node.txt_descripcion,
      type: tipo,
      level: level,
      menu_padre : node.fk_menu_padre,
      id_opcion_menu : node.id_opcion_menu,
      txt_ruta : node.txt_ruta,
      ind_estado : node.ind_estado,
      expandable: !!node.child
    };
  }

  /** Get the level of the node */
  getLevel(node: FlatTreeNode) {
    return node.level;
  }

  /** Get whether the node is expanded or not. */
  isExpandable(node: FlatTreeNode) {
    return node.expandable;
  }

  /** Get whether the node has children or not. */
  hasChild(index: number, node: FlatTreeNode) {
    return node.expandable;
  }

  /** Get the children for the node. */
  getChildren(node: Menu): Menu[] | null | undefined {
    return node.child;
  }

  /**
   * se encarga de mostrar el modal para la creacion de un menu.
   * @param id_menu_padre identificador del menu padre de ser necesario
   */
  add_menu(id_menu_padre ? : number ){

    if(id_menu_padre){
      this.menu_serv.id_menu_padre = id_menu_padre;
    }

    const dialogRef = this.dialog.open(EditarMenuComponent, {
      width: '400px',
    });

    dialogRef.afterClosed()
    .subscribe(
      ()=>{
        this.reload_data();
      }
    );

    this.menu_serv.dialog_ref = dialogRef;
  }

  /**
   * Funcion que se encarga de realizar la edicion de un menu.
   * @param menu menu que se va editar
   */
  edit_menu(menu : any){
    this.menu_serv.id_menu_padre = menu.menu_padre;
    this.menu_serv.id_opcion_menu = menu.id_opcion_menu;
    this.menu_serv.menu_edit = menu;

    const dialogRef = this.dialog.open(EditarMenuComponent, {width : '400px'});

    dialogRef.afterClosed()
             .subscribe(
               ()=>{
                  this.reload_data();               
               }
             );

    this.menu_serv.dialog_ref = dialogRef;
  }

  /**
   * Funcion que se encarga de recarga la data necesaria para el formulario de edicion
   */
  reload_data(){
    this.menu_serv.id_opcion_menu = null;
    this.menu_serv.id_menu_padre = null;
    this.menu_serv.menu_edit = null;
    let data = {}
    data ["app"] = this.app_serv.get_aplicacion().id_aplicacion;
    
    if(this.mod_serv.id_modulo){
      data['fk_modulo'] = this.mod_serv.id_modulo;
    }

    this.menu_serv.consultar_menus(data)
        .then(
          ()=>{
            this.dataSource.data = this.menu_serv.menu;
            this.menu_serv.id_menu_padre = null;
          }
        ); 
  }

}
